import { StyleSheet, } from '@react-pdf/renderer';

export const stylesDefensoresNucleo = StyleSheet.create(
  {
    page: {
      padding: 20,
      fontSize: 9,
      flexDirection: 'column',
      fontFamily: 'Helvetica',
    },
    title: {
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 8,
      fontWeight: 'bold',
    },
    updated: {
      fontSize: 9,
      textAlign: 'right',
      marginTop: 10,
      fontStyle: 'italic',
    },
    table: {
      flexDirection: 'column',
      width: '100%',
      borderTopWidth: 1,
      borderLeftWidth: 1,
      borderColor: '#000000',
    },
    tableRow: {
      flexDirection: 'row',
    },
    tableRowOdd: {
      backgroundColor: '#f5f5f5',
    },
    tableRowEven: {
      backgroundColor: '#ffffff',
    },
    headerCell: {
      padding: 5,
      fontWeight: 'bold',
      backgroundColor: '#e0e6ed',
      textAlign: 'center',
      borderRightWidth: 1,
      borderBottomWidth: 1,
      borderColor: '#000000',
    },
    tableCell: {
      padding: 4,
      textAlign: 'left',
      borderRightWidth: 1,
      borderBottomWidth: 1,
      borderColor: '#000000',
    },
    lastCell: {
      // Mantido para compatibilidade; a borda direita já é aplicada em todas as células
    },
    integrante: {
      marginBottom: 2,
    },
    nomeDiretor: {
      marginBottom: 2,
      fontWeight: 'bold',
    },
    inativo: {
      marginBottom: 2,
      textDecoration: 'line-through',
      color: 'gray',
    },
  });